var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"button-text-router-link",class:[_vm.styleClassName, _vm.sizeClassName],attrs:{"to":_vm.to}},[_c('span',{staticClass:"button-text-router-link__text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }